
shadow.loader.init("");
frontend.core.init();